'use strict';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';


export function IconView(props) {
  return (
    <i className={classNames("Icon", props.icon, props.className)} />
  );
}

IconView.propTypes = {
  className: T.string,
  icon: T.string.isRequired,
};

IconView.defaultProps = {
  className: '',
};



// WEBPACK FOOTER //
// ./src/js/components/Icon/IconView.js